import { isEqual } from "@common/helpers/comparison";
import { stableStringify } from "@common/helpers/stableStringify";
import {
    TransactionRuleActionDefinition,
    TransactionRuleConditionDefinition,
    TransferRuleDirection,
} from "@common/types/transactionRule";

interface RuleContentEntry {
    transferDirection?: TransferRuleDirection | null;
}

export interface RuleContent {
    conditions: Array<
        Pick<TransactionRuleConditionDefinition, "conditionType" | "value"> &
            RuleContentEntry
    >;
    actions: Array<
        Pick<TransactionRuleActionDefinition, "actionType" | "value"> &
            RuleContentEntry
    >;
}

export interface NormalizedRuleContent {
    conditions: string[];
    actions: string[];
}

function toSortedEntries(entries: object[]): string[] {
    return entries
        .map((entry) => stableStringify(entry, { dropNullishKeys: true }))
        .sort((a, b) => a.localeCompare(b));
}

export function normalizeRuleContent(rule: RuleContent): NormalizedRuleContent {
    return {
        conditions: toSortedEntries(
            rule.conditions.map(
                ({ conditionType, value, transferDirection }) => ({
                    conditionType,
                    value,
                    transferDirection,
                }),
            ),
        ),
        actions: toSortedEntries(
            rule.actions.map(({ actionType, value, transferDirection }) => ({
                actionType,
                value,
                transferDirection,
            })),
        ),
    };
}

export function hasSameRuleContent(a: RuleContent, b: RuleContent): boolean {
    return isEqual(normalizeRuleContent(a), normalizeRuleContent(b));
}
